import * as Icons from "lucide-react";

export function CategoryIcon({ name, className = "w-5 h-5" }) {
  const Comp = Icons[name] || Icons.Tag;
  return <Comp className={className} strokeWidth={2} />;
}
